import { render } from "./Watchlist.vue?vue&type=template&id=3db512f2&scoped=true"
import script from "./Watchlist.vue?vue&type=script&lang=js"
export * from "./Watchlist.vue?vue&type=script&lang=js"

import "./Watchlist.vue?vue&type=style&index=0&id=3db512f2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3db512f2"]])

export default __exports__